// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section{
    margin-top: 86px;
}
.rate{
    /* background-color: #F0F9FF; */
    padding: 32px 2px 90px 2px;
    background: linear-gradient(181deg, #F0F9FF 30%, white 100%);
}
.gradient{
    background: linear-gradient(181deg, #F0F9FF 30%, white 100%);
}
.content{
    position: relative;
}
.content img{
    position: relative;
    width: 50%;
}
.nav li:before {
    content: '✓';
    color: #17c7fc;
    font-size: 22px;
  }
h6{
    font-size: 14px;
}
.rate .form-control{
    /* width: 75%; */
    height: calc(3em + 0rem + 0px);
    background-color:#eef5fa !important;
    color: #000;
}
.workbox:hover{
    background-color: #fff!important;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 5px 10px 20px #00000029;
    border-radius: 20px;
    transform: scale(1.05);
    box-shadow: 0 10px 20px rgba(0,0,0,.12), 0 4px 8px rgba(0,0,0,.06);
}





.select-con{
    border-radius: 6px;
    height: 56px !important;
    align-content: center;
    text-align: left;
    align-items: center;
    line-height: 2.5;
    padding: 7px !important;
    position: relative;
    cursor: pointer;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;                                                                   
}
.select-con span{
    font-size: 15px;
}
.select-con .material-icons{
    position: absolute;
    right: 0;
    top: 16px;
    font-size: 28px;
}
.country{
    position: absolute;
    list-style: none;
    display: block;
    padding: 0px;
    border: 1px solid #ced4da;
    border-bottom-left-radius: 6px; /* Set the bottom-left border radius */
    border-bottom-right-radius: 6px;
    background: white;
    z-index: 7;
    height: 350px;
    overflow-y: scroll;
    top: 60px;
}
.w-60{
    width:70%;
}
.w-40{
    width:30%;
}
.country li{
    padding: 12px 8px;
    text-align: left;
    font-size: 15px;
    border-bottom: 1px solid #ced4da;
    display: flex;
}
.country li:last-child{
    border-bottom: 0px solid #ced4da;
}
.country li img, .select-con img{
    width: 20%;
    padding-right: 10px;
}

@media screen and (max-width:600px){
    section {
        margin-top: 64px;
    }
    .mat-mdc-form-field {
        width: 90% !important;
    }
    .content{
        text-align: center;
    }
}



.b-12{
    border-top: 1px solid #bcbcbc;
    border-bottom: 1px solid #bcbcbc;
}
.total{
    /* border-left: 1px solid #bcbcbc; */
    font-size: 24px;
    color: #10C7FC;
    /* margin-left: 24px; */
    padding-left: 24px;
    font-weight: 500;
}
.btn-pay{
    color: white;
    padding: 1.25rem 2rem;
    background: #10C7FC;
    border: none;
    font-size: 24px;
    border-radius: 32px;
    font-weight: 600;
}
.btn-main{
    background: #10C7FC;
}
p{
    margin: 0;
    font-size: 15px;
}
ul{
    list-style: none;
}
li{
    font-size: 14px;
}
.arrow li:before {
    content: '✓';
    color: #17c7fc;
    font-size: 22px;
}
 

 .input-group {
    position: relative !important;
    left: 0 !important;
    top: 0px !important;
    width: 100% !important;
  }
 
.bg-darkblue{
    background-color: #1174bb;
}
.border-right-radius{
    border-top-left-radius: 0rem!important;
    border-bottom-left-radius: 0rem!important;
}
marquee{
    line-height:12px;
}
.marquee{
    background: #d0eaff;
    padding: 10px;
    width: 100%;
}
/* section{
    margin: 3rem 0rem;
} */
.banner-section{
    /* background:#215D88 !important; */
    /* background: #0070C0 !important; */
    margin-top: 80px;
    background: linear-gradient(
        125deg, #0070C0 50%, #0070c011 40%);

}
.book-cont{
    padding: 32px 80px;
    position: relative;
}
.book-cont::after{
    position: absolute;
    content: '';
    width: 2px;
    height: 90%;
    top: 12px;
    background-color: white;
    left: 30px;
}
.play{
    position: relative;
    width: 10%;
    right: 70px;
    display: none;
}
.book{
    color: #000;
    padding: 0.75rem 1.5rem;
    background: #10C7FC;
    border: none;
    border-radius: 24px;
    line-height: 36px;
    margin-top: 32px;
    font-weight: 600;
    font-size: 20px;
}
.register{
    color: #fff;
    padding: .25rem 1rem;
    background: #ed7c30;
    border: none;
    border-radius: 10px ;
    line-height: 36px;
}
.w-15{
    width: 15% !important;
}
h1{
    font-weight: 700;
    font-size: 30px;
}
.center{
    padding: 1rem 3rem;
     
}.center h1{
       
    min-height:80px;
}
.heads{
    color: #0EC6FB;
    font-size: 48px;
    font-weight: 700;
}
.sub-head{
    font-family: HaloHandletter;
    color: #0070BF;
    font-size: 64px;
    position: relative;
    bottom: 12px;
}
.bg-image-1{
    background-image: url(/assets/images/1_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-2{
    background-image: url(/assets/images/2_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-3{ 
    background-image: url(/assets/images/3_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-4{
    background-image: url(/assets/images/1_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-5{
    background-image: url(/assets/images/2_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-6{ 
    background-image: url(/assets/images/3_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-7{
    background-image: url(/assets/images/1_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-8{
    background-image: url(/assets/images/2_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-9{ 
    background-image: url(/assets/images/3_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-10{
    background-image: url(/assets/images/1_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-11{
    background-image: url(/assets/images/2_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.bg-image-12{ 
    background-image: url(/assets/images/3_back.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.name-content{
    position: relative;
    /* top: 40px; */
    color: white;
    right: 16px;
    padding-top: 48px;
}
.name-content span{
    font-weight: 600;
    font-size: 14px;
}
.educat{
    margin-top: 6.5rem;
}
.top-image{
    position: relative;
    bottom: 40px;
    margin-bottom: -40px;
}
.w-55{
    /* width: 55%; */
    width: 250px;
}
.working{
   background: #F4FBFF;
}
.seamless{
    background-image: url(/assets/images/seamless_background.png);
    background-repeat: no-repeat;
    background-size: cover;
}
.blog_back{
    background-image: url(/assets/images/blog_background.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #215D88;
}

#community .carousel-indicators li{
    background-color: #215D88 !important;
}
.store{
    width: 45%;
    /* height: 12vh; */
    margin: auto;
}
.card{
    box-shadow: 0px 2px 23px #00000029;
    cursor: pointer;
    background: white;
    color: black;
    margin: .5rem;
}
.blog_back .card:hover {
    box-shadow: 0 10px 20px rgba(0,0,0,.22), 0 6px 6px rgba(0,0,0,.1);
}
.card-title{
    text-transform: capitalize;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    text-align: left;
    min-height: 100px;
    line-height: 21px;
}
.card-text{
    text-align: left;
    font-size: 13px;
    margin-bottom: 20px;
    line-height: 18px;
}
 .card-title, .card-block p , .card-block span{
    color: black !important;
}
.carousel-item {
    min-height: 200px;}
.carousel-indicators{
    top: 100%;
    padding-top: 8%;
}
.carousel-indicators li{
    background-color: white !important;
    width: 10px;
    height: 10px;
    border-radius: 100%;
 }
 .w-65{
     width: 65%;
 }
 .get{
    color: #FFA901; 
    font-size: 55px;
    font-weight: 700;
 }
 .working-text span {
     color: #215D88;
     font-weight: 700;
     font-size: 16px;
 }
 .working-text span:nth-child(1){
    position: absolute;
    top: 5%;
    left: 45%;
 }
 .working-text span:nth-child(2){
    position: absolute;
    top: 20%;
    left: 65%;
 }
 .working-text span:nth-child(3){
    position: absolute;
    top: 46%;
    left: 72%;
 }
 .working-text span:nth-child(4){
    position: absolute;
    top: 74%;
    left: 67%;
 }
 .working-text span:nth-child(5){
    position: absolute;
    top: 90%;
    left: 45%;
 }
 .working-detail p {
    color: black;
    font-size: 16px;
    font-weight: 400;
    padding: 0 2rem;
}
 .working-detail p:nth-child(1){
    position: absolute;
    top: 5%;
 }
 .working-detail p:nth-child(2){
    position: absolute;
    top: 20%;
 }
 .working-detail p:nth-child(3){
    position: absolute;
    top: 46%;
 }
 .working-detail p:nth-child(4){
    position: absolute;
    top: 74%;
 }
 .working-detail p:nth-child(5){
    position: absolute;
    top: 88%;
 }
 .compare-container {
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
}

.compare-text-button {
    color: #1174bb;
    font-size: 17px;
    font-weight: 600;
}
 .coming{
    font-size: 32px;
    font-weight: 800;
    border: 4px solid #16c6fb;
    padding: 12px;
 }
 .view{
    color: #16c6fb;
    cursor: pointer;
    text-decoration: underline;
}
@media screen and (max-width:600px){

    .center h1{
        min-height:78px;
    }
    .banner-section {
        margin-top: 65px;
    }
    h1{
        font-size: 20px;
    }
    .center{
        padding: 1rem;
    }
    .heads{
        font-size: 28px;
    }
    .sub-head{
        font-size: 36px;
        bottom: 8px;
    }
    .carousel-item{
        text-align: center;
    }
    .store{
        width: 40%;
        /* height: 10vh; */
        /* margin: 2px; */
    }
    .w-42{
        width: 100%;
    }
    .w-55{
        width: 50%;
    }
    .get{
        font-size: 22px;
     }
     .carousel-indicators{
        top: 100%;
        padding-top: 0;
    }
    .media{
        margin: 1rem .5rem;
    }
    .media img{
        width: 20%;
    }
    .coming{
        font-size: 16px;
    }
    .banner-section{
        margin-top: 10px;
        /* background: #0070C0 !important; */
        background: linear-gradient( 
183deg, #0070c011 50%, #17c7fc 62%) !important;
    }
    /* h6{
        color: white !important;
    } */
    .tag{
        padding-left: 1% !important;
    }
    ul li{
        font-size: 13px;
    }
    ul li:before {
        font-size: 16px;
      }
    /* .s-bg{
        background-color: #17c7fc !important;
    } */
    .country li img, .select-con img{
        width: 47% !important;
        padding-right: 12 !important;
    }
}
@media (min-width: 1600px) {
    .country li img, .select-con img {
        width: 18% !important;
        padding-right: 10px !important; /* Added 'px' to the padding value */
    }
}
.nav li:before {
    content: '✓';
    color: #17c7fc;
    font-size: 22px;
  }







/* 
  select option[id="USD"]   { background-image:url(/assets/images/Reeudo-Black.png);   }  */

.rate .form-control{
    /* width: 75%; */
    height: calc(3em + .75rem + 2px);
    background-color:#eef5fa !important;
    color: #000;
}
.tag{
    padding-left: 18%;
}



.select-con{
    border: 1px solid #333;
    border-radius: 6px;
    height: 62px;
    align-content: center;
    text-align: left;
    align-items: center;
    line-height: 2.5;
    padding: 12px;
    position: relative;
    cursor: pointer;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;                                                                   
}
.select-con span{
    font-size: 15px;
}
.select-con .material-icons{
    position: absolute;
    right: 0;
    top: 16px;
    font-size: 28px;
}
.country{
    position: absolute;
    list-style: none;
    display: block;
    padding: 0px;
    border: 1px solid #ced4da;
    background: white;
    z-index: 7;
    height: 350px;
    overflow-y: scroll;
    top: 57px;
    max-width: 92%;
}
.country li{
    padding: 12px 8px;
    text-align: left;
    font-size: 15px;
    border-bottom: 1px solid #ced4da;
    display: flex;
}
.country li:last-child{
    border-bottom: 0px solid #ced4da;
}
.country li img, .select-con img{
    width: 22%;
    padding-right: 10px;
}



marquee{
    line-height:12px;
}
.marquee{
    background: #d0eaff;
    padding: 5px;
    width: 100%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.close{
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
    z-index: 9;
    color: black;
    background: white;
    padding: 8px 10px;
    font-size: 15px;
    border-radius: 22px;
}
.web-scrollmenu {
    white-space: inherit;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-scrollbar-width: none;
    padding-right: 0rem;
}
.web-scrollmenu::-webkit-scrollbar {
    display: none;
}
.scroll-right{
    right:40px;
    top: 47%;
    z-index: 1;
    font-size: 16px;
}
.right-button{
    border-radius:50%;
}
.scroll-left{
    left:30px;
    top: 47%;
    z-index: 1;
    font-size: 16px;
}
.left-button{
    border-radius:50%;
}
.slick-slider {
    width: 88%;
    margin: auto;
    background: rgb(14, 13, 13);
  }
    
body .slick-prev, 
body .slick-next {
    height: 45px;
    width: 40px;
    background: #575d59 !important;
    z-index: 100;
}
.mat-mdc-form-text-infix{
    display: flex !important;;
}
.font-weight-500{
    font-weight: 450;
}
.work{
    background: #F4F5F7 0% 0% no-repeat padding-box;
box-shadow: 5px 10px 20px #00000029;
border-radius: 20px;
opacity: 1;
}
@media (max-width: 767px) {
    /* Reduce font size for buttons */
    .cardapply {
        font-size: 8px;
    }

    /* Reduce placeholder font size for the input */
    input::placeholder {
        font-size: 9px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/zengage-home/zengage-home.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,4DAA4D;AAChE;AACA;IACI,4DAA4D;AAChE;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;AACF;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,mCAAmC;IACnC,WAAW;AACf;AACA;IACI,gCAAgC;IAChC,+CAA+C;IAC/C,mCAAmC;IACnC,mBAAmB;IACnB,sBAAsB;IACtB,kEAAkE;AACtE;;;;;;AAMA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,8BAA8B,EAAE,sCAAsC;IACtE,+BAA+B;IAC/B,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,aAAa;AACjB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,kBAAkB;IACtB;AACJ;;;;AAIA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;AACA;IACI,oCAAoC;IACpC,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;;CAGC;IACG,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;EACxB;;AAEF;IACI,yBAAyB;AAC7B;AACA;IACI,sCAAsC;IACtC,yCAAyC;AAC7C;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;AACA;;GAEG;AACH;IACI,mCAAmC;IACnC,oCAAoC;IACpC,gBAAgB;IAChB;2CACuC;;AAE3C;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;AACjB;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;;AAEtB,CAAC;;IAEG,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;GACG,mBAAmB;AACtB;AACA;IACI,6DAA6D;IAC7D,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,yDAAyD;IACzD,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kCAAkC;IAClC,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,iEAAiE;AACrE;AACA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;CACC;IACG,uBAAuB;AAC3B;AACA;IACI,iBAAiB,CAAC;AACtB;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,mBAAmB;CACtB;CACA;KACI,UAAU;CACd;CACA;IACG,cAAc;IACd,eAAe;IACf,gBAAgB;CACnB;CACA;KACI,cAAc;KACd,gBAAgB;KAChB,eAAe;CACnB;CACA;IACG,kBAAkB;IAClB,OAAO;IACP,SAAS;CACZ;CACA;IACG,kBAAkB;IAClB,QAAQ;IACR,SAAS;CACZ;CACA;IACG,kBAAkB;IAClB,QAAQ;IACR,SAAS;CACZ;CACA;IACG,kBAAkB;IAClB,QAAQ;IACR,SAAS;CACZ;CACA;IACG,kBAAkB;IAClB,QAAQ;IACR,SAAS;CACZ;CACA;IACG,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;CACC;IACG,kBAAkB;IAClB,OAAO;CACV;CACA;IACG,kBAAkB;IAClB,QAAQ;CACX;CACA;IACG,kBAAkB;IAClB,QAAQ;CACX;CACA;IACG,kBAAkB;IAClB,QAAQ;CACX;CACA;IACG,kBAAkB;IAClB,QAAQ;CACX;CACA;IACG,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;CACC;IACG,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;CAChB;CACA;IACG,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;AACA;;IAEI;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;KAClB;KACA;QACG,SAAS;QACT,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,oCAAoC;QACpC;8CACsC;IAC1C;IACA;;OAEG;IACH;QACI,2BAA2B;IAC/B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;MACjB;IACF;;OAEG;IACH;QACI,qBAAqB;QACrB,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,qBAAqB;QACrB,8BAA8B,EAAE,oCAAoC;IACxE;AACJ;AACA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;;;;;;;AAQF;2FAC2F;;AAE3F;IACI,gBAAgB;IAChB,gCAAgC;IAChC,mCAAmC;IACnC,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;;;;AAIA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,aAAa;AACjB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;;;AAIA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,SAAS;IACT,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,YAAY;IACZ,2BAA2B;EAC7B;;AAEF;;IAEI,YAAY;IACZ,WAAW;IACX,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,+CAA+C;AACnD,mCAAmC;AACnC,mBAAmB;AACnB,UAAU;AACV;AACA;IACI,iCAAiC;IACjC;QACI,cAAc;IAClB;;IAEA,+CAA+C;IAC/C;QACI,cAAc;IAClB;AACJ","sourcesContent":["section{\n    margin-top: 86px;\n}\n.rate{\n    /* background-color: #F0F9FF; */\n    padding: 32px 2px 90px 2px;\n    background: linear-gradient(181deg, #F0F9FF 30%, white 100%);\n}\n.gradient{\n    background: linear-gradient(181deg, #F0F9FF 30%, white 100%);\n}\n.content{\n    position: relative;\n}\n.content img{\n    position: relative;\n    width: 50%;\n}\n.nav li:before {\n    content: '✓';\n    color: #17c7fc;\n    font-size: 22px;\n  }\nh6{\n    font-size: 14px;\n}\n.rate .form-control{\n    /* width: 75%; */\n    height: calc(3em + 0rem + 0px);\n    background-color:#eef5fa !important;\n    color: #000;\n}\n.workbox:hover{\n    background-color: #fff!important;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 5px 10px 20px #00000029;\n    border-radius: 20px;\n    transform: scale(1.05);\n    box-shadow: 0 10px 20px rgba(0,0,0,.12), 0 4px 8px rgba(0,0,0,.06);\n}\n\n\n\n\n\n.select-con{\n    border-radius: 6px;\n    height: 56px !important;\n    align-content: center;\n    text-align: left;\n    align-items: center;\n    line-height: 2.5;\n    padding: 7px !important;\n    position: relative;\n    cursor: pointer;\n    font-size: 16px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;                                                                   \n}\n.select-con span{\n    font-size: 15px;\n}\n.select-con .material-icons{\n    position: absolute;\n    right: 0;\n    top: 16px;\n    font-size: 28px;\n}\n.country{\n    position: absolute;\n    list-style: none;\n    display: block;\n    padding: 0px;\n    border: 1px solid #ced4da;\n    border-bottom-left-radius: 6px; /* Set the bottom-left border radius */\n    border-bottom-right-radius: 6px;\n    background: white;\n    z-index: 7;\n    height: 350px;\n    overflow-y: scroll;\n    top: 60px;\n}\n.w-60{\n    width:70%;\n}\n.w-40{\n    width:30%;\n}\n.country li{\n    padding: 12px 8px;\n    text-align: left;\n    font-size: 15px;\n    border-bottom: 1px solid #ced4da;\n    display: flex;\n}\n.country li:last-child{\n    border-bottom: 0px solid #ced4da;\n}\n.country li img, .select-con img{\n    width: 20%;\n    padding-right: 10px;\n}\n\n@media screen and (max-width:600px){\n    section {\n        margin-top: 64px;\n    }\n    .mat-mdc-form-field {\n        width: 90% !important;\n    }\n    .content{\n        text-align: center;\n    }\n}\n\n\n\n.b-12{\n    border-top: 1px solid #bcbcbc;\n    border-bottom: 1px solid #bcbcbc;\n}\n.total{\n    /* border-left: 1px solid #bcbcbc; */\n    font-size: 24px;\n    color: #10C7FC;\n    /* margin-left: 24px; */\n    padding-left: 24px;\n    font-weight: 500;\n}\n.btn-pay{\n    color: white;\n    padding: 1.25rem 2rem;\n    background: #10C7FC;\n    border: none;\n    font-size: 24px;\n    border-radius: 32px;\n    font-weight: 600;\n}\n.btn-main{\n    background: #10C7FC;\n}\np{\n    margin: 0;\n    font-size: 15px;\n}\nul{\n    list-style: none;\n}\nli{\n    font-size: 14px;\n}\n.arrow li:before {\n    content: '✓';\n    color: #17c7fc;\n    font-size: 22px;\n}\n \n\n .input-group {\n    position: relative !important;\n    left: 0 !important;\n    top: 0px !important;\n    width: 100% !important;\n  }\n \n.bg-darkblue{\n    background-color: #1174bb;\n}\n.border-right-radius{\n    border-top-left-radius: 0rem!important;\n    border-bottom-left-radius: 0rem!important;\n}\nmarquee{\n    line-height:12px;\n}\n.marquee{\n    background: #d0eaff;\n    padding: 10px;\n    width: 100%;\n}\n/* section{\n    margin: 3rem 0rem;\n} */\n.banner-section{\n    /* background:#215D88 !important; */\n    /* background: #0070C0 !important; */\n    margin-top: 80px;\n    background: linear-gradient(\n        125deg, #0070C0 50%, #0070c011 40%);\n\n}\n.book-cont{\n    padding: 32px 80px;\n    position: relative;\n}\n.book-cont::after{\n    position: absolute;\n    content: '';\n    width: 2px;\n    height: 90%;\n    top: 12px;\n    background-color: white;\n    left: 30px;\n}\n.play{\n    position: relative;\n    width: 10%;\n    right: 70px;\n    display: none;\n}\n.book{\n    color: #000;\n    padding: 0.75rem 1.5rem;\n    background: #10C7FC;\n    border: none;\n    border-radius: 24px;\n    line-height: 36px;\n    margin-top: 32px;\n    font-weight: 600;\n    font-size: 20px;\n}\n.register{\n    color: #fff;\n    padding: .25rem 1rem;\n    background: #ed7c30;\n    border: none;\n    border-radius: 10px ;\n    line-height: 36px;\n}\n.w-15{\n    width: 15% !important;\n}\nh1{\n    font-weight: 700;\n    font-size: 30px;\n}\n.center{\n    padding: 1rem 3rem;\n     \n}.center h1{\n       \n    min-height:80px;\n}\n.heads{\n    color: #0EC6FB;\n    font-size: 48px;\n    font-weight: 700;\n}\n.sub-head{\n    font-family: HaloHandletter;\n    color: #0070BF;\n    font-size: 64px;\n    position: relative;\n    bottom: 12px;\n}\n.bg-image-1{\n    background-image: url(/assets/images/1_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-2{\n    background-image: url(/assets/images/2_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-3{ \n    background-image: url(/assets/images/3_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-4{\n    background-image: url(/assets/images/1_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-5{\n    background-image: url(/assets/images/2_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-6{ \n    background-image: url(/assets/images/3_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-7{\n    background-image: url(/assets/images/1_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-8{\n    background-image: url(/assets/images/2_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-9{ \n    background-image: url(/assets/images/3_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-10{\n    background-image: url(/assets/images/1_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-11{\n    background-image: url(/assets/images/2_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.bg-image-12{ \n    background-image: url(/assets/images/3_back.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.name-content{\n    position: relative;\n    /* top: 40px; */\n    color: white;\n    right: 16px;\n    padding-top: 48px;\n}\n.name-content span{\n    font-weight: 600;\n    font-size: 14px;\n}\n.educat{\n    margin-top: 6.5rem;\n}\n.top-image{\n    position: relative;\n    bottom: 40px;\n    margin-bottom: -40px;\n}\n.w-55{\n    /* width: 55%; */\n    width: 250px;\n}\n.working{\n   background: #F4FBFF;\n}\n.seamless{\n    background-image: url(/assets/images/seamless_background.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.blog_back{\n    background-image: url(/assets/images/blog_background.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-color: #215D88;\n}\n\n#community .carousel-indicators li{\n    background-color: #215D88 !important;\n}\n.store{\n    width: 45%;\n    /* height: 12vh; */\n    margin: auto;\n}\n.card{\n    box-shadow: 0px 2px 23px #00000029;\n    cursor: pointer;\n    background: white;\n    color: black;\n    margin: .5rem;\n}\n.blog_back .card:hover {\n    box-shadow: 0 10px 20px rgba(0,0,0,.22), 0 6px 6px rgba(0,0,0,.1);\n}\n.card-title{\n    text-transform: capitalize;\n    font-size: 16px;\n    font-weight: bold;\n    color: #000;\n    text-align: left;\n    min-height: 100px;\n    line-height: 21px;\n}\n.card-text{\n    text-align: left;\n    font-size: 13px;\n    margin-bottom: 20px;\n    line-height: 18px;\n}\n .card-title, .card-block p , .card-block span{\n    color: black !important;\n}\n.carousel-item {\n    min-height: 200px;}\n.carousel-indicators{\n    top: 100%;\n    padding-top: 8%;\n}\n.carousel-indicators li{\n    background-color: white !important;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n }\n .w-65{\n     width: 65%;\n }\n .get{\n    color: #FFA901; \n    font-size: 55px;\n    font-weight: 700;\n }\n .working-text span {\n     color: #215D88;\n     font-weight: 700;\n     font-size: 16px;\n }\n .working-text span:nth-child(1){\n    position: absolute;\n    top: 5%;\n    left: 45%;\n }\n .working-text span:nth-child(2){\n    position: absolute;\n    top: 20%;\n    left: 65%;\n }\n .working-text span:nth-child(3){\n    position: absolute;\n    top: 46%;\n    left: 72%;\n }\n .working-text span:nth-child(4){\n    position: absolute;\n    top: 74%;\n    left: 67%;\n }\n .working-text span:nth-child(5){\n    position: absolute;\n    top: 90%;\n    left: 45%;\n }\n .working-detail p {\n    color: black;\n    font-size: 16px;\n    font-weight: 400;\n    padding: 0 2rem;\n}\n .working-detail p:nth-child(1){\n    position: absolute;\n    top: 5%;\n }\n .working-detail p:nth-child(2){\n    position: absolute;\n    top: 20%;\n }\n .working-detail p:nth-child(3){\n    position: absolute;\n    top: 46%;\n }\n .working-detail p:nth-child(4){\n    position: absolute;\n    top: 74%;\n }\n .working-detail p:nth-child(5){\n    position: absolute;\n    top: 88%;\n }\n .compare-container {\n    margin-top: 0rem !important;\n    margin-bottom: 0rem !important;\n}\n\n.compare-text-button {\n    color: #1174bb;\n    font-size: 17px;\n    font-weight: 600;\n}\n .coming{\n    font-size: 32px;\n    font-weight: 800;\n    border: 4px solid #16c6fb;\n    padding: 12px;\n }\n .view{\n    color: #16c6fb;\n    cursor: pointer;\n    text-decoration: underline;\n}\n@media screen and (max-width:600px){\n\n    .center h1{\n        min-height:78px;\n    }\n    .banner-section {\n        margin-top: 65px;\n    }\n    h1{\n        font-size: 20px;\n    }\n    .center{\n        padding: 1rem;\n    }\n    .heads{\n        font-size: 28px;\n    }\n    .sub-head{\n        font-size: 36px;\n        bottom: 8px;\n    }\n    .carousel-item{\n        text-align: center;\n    }\n    .store{\n        width: 40%;\n        /* height: 10vh; */\n        /* margin: 2px; */\n    }\n    .w-42{\n        width: 100%;\n    }\n    .w-55{\n        width: 50%;\n    }\n    .get{\n        font-size: 22px;\n     }\n     .carousel-indicators{\n        top: 100%;\n        padding-top: 0;\n    }\n    .media{\n        margin: 1rem .5rem;\n    }\n    .media img{\n        width: 20%;\n    }\n    .coming{\n        font-size: 16px;\n    }\n    .banner-section{\n        margin-top: 10px;\n        /* background: #0070C0 !important; */\n        background: linear-gradient( \n183deg, #0070c011 50%, #17c7fc 62%) !important;\n    }\n    /* h6{\n        color: white !important;\n    } */\n    .tag{\n        padding-left: 1% !important;\n    }\n    ul li{\n        font-size: 13px;\n    }\n    ul li:before {\n        font-size: 16px;\n      }\n    /* .s-bg{\n        background-color: #17c7fc !important;\n    } */\n    .country li img, .select-con img{\n        width: 47% !important;\n        padding-right: 12 !important;\n    }\n}\n@media (min-width: 1600px) {\n    .country li img, .select-con img {\n        width: 18% !important;\n        padding-right: 10px !important; /* Added 'px' to the padding value */\n    }\n}\n.nav li:before {\n    content: '✓';\n    color: #17c7fc;\n    font-size: 22px;\n  }\n\n\n\n\n\n\n\n/* \n  select option[id=\"USD\"]   { background-image:url(/assets/images/Reeudo-Black.png);   }  */\n\n.rate .form-control{\n    /* width: 75%; */\n    height: calc(3em + .75rem + 2px);\n    background-color:#eef5fa !important;\n    color: #000;\n}\n.tag{\n    padding-left: 18%;\n}\n\n\n\n.select-con{\n    border: 1px solid #333;\n    border-radius: 6px;\n    height: 62px;\n    align-content: center;\n    text-align: left;\n    align-items: center;\n    line-height: 2.5;\n    padding: 12px;\n    position: relative;\n    cursor: pointer;\n    font-size: 16px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;                                                                   \n}\n.select-con span{\n    font-size: 15px;\n}\n.select-con .material-icons{\n    position: absolute;\n    right: 0;\n    top: 16px;\n    font-size: 28px;\n}\n.country{\n    position: absolute;\n    list-style: none;\n    display: block;\n    padding: 0px;\n    border: 1px solid #ced4da;\n    background: white;\n    z-index: 7;\n    height: 350px;\n    overflow-y: scroll;\n    top: 57px;\n    max-width: 92%;\n}\n.country li{\n    padding: 12px 8px;\n    text-align: left;\n    font-size: 15px;\n    border-bottom: 1px solid #ced4da;\n    display: flex;\n}\n.country li:last-child{\n    border-bottom: 0px solid #ced4da;\n}\n.country li img, .select-con img{\n    width: 22%;\n    padding-right: 10px;\n}\n\n\n\nmarquee{\n    line-height:12px;\n}\n.marquee{\n    background: #d0eaff;\n    padding: 5px;\n    width: 100%;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n}\n.close{\n    position: absolute;\n    right: 16px;\n    top: 16px;\n    cursor: pointer;\n    z-index: 9;\n    color: black;\n    background: white;\n    padding: 8px 10px;\n    font-size: 15px;\n    border-radius: 22px;\n}\n.web-scrollmenu {\n    white-space: inherit;\n    overflow-x: auto;\n    overflow-y: hidden;\n    flex-wrap: nowrap;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    -webkit-scrollbar-width: none;\n    padding-right: 0rem;\n}\n.web-scrollmenu::-webkit-scrollbar {\n    display: none;\n}\n.scroll-right{\n    right:40px;\n    top: 47%;\n    z-index: 1;\n    font-size: 16px;\n}\n.right-button{\n    border-radius:50%;\n}\n.scroll-left{\n    left:30px;\n    top: 47%;\n    z-index: 1;\n    font-size: 16px;\n}\n.left-button{\n    border-radius:50%;\n}\n.slick-slider {\n    width: 88%;\n    margin: auto;\n    background: rgb(14, 13, 13);\n  }\n    \nbody .slick-prev, \nbody .slick-next {\n    height: 45px;\n    width: 40px;\n    background: #575d59 !important;\n    z-index: 100;\n}\n.mat-mdc-form-text-infix{\n    display: flex !important;;\n}\n.font-weight-500{\n    font-weight: 450;\n}\n.work{\n    background: #F4F5F7 0% 0% no-repeat padding-box;\nbox-shadow: 5px 10px 20px #00000029;\nborder-radius: 20px;\nopacity: 1;\n}\n@media (max-width: 767px) {\n    /* Reduce font size for buttons */\n    .cardapply {\n        font-size: 8px;\n    }\n\n    /* Reduce placeholder font size for the input */\n    input::placeholder {\n        font-size: 9px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
